<template>
	<div class="index">
		<!-- banner图 -->
		<div class="newsCenterBanenr">
			<img src="../../assets/xiangning/dwgk/dwgk_banner.png" v-if="$route.query.type == 'dwgk'">
			<img src="../../assets/xiangning/newsCenter/newCenter_banner.png" v-if="$route.query.type == 'xwzx'">
			<img src="../../assets/xiangning/newsCenter/djgj_banner.png" v-if="$route.query.type == 'djgj'">
		</div>
		<div class="home_wrap">
			<!-- 新闻中心上方标题栏 -->
			<div class="news_title" v-if="$route.query.type == 'xwzx'">
				<div class="title_left">
					<img src="../../assets/xiangning/home/titile_left.png" alt="">
				</div>
				<div class="news_title_left">
					<div @click="changeNewsNum(1)" class="news_title_left_text"
						:style="{ color: NewsNum == 1 ? '#D31813' : '#999999', fontWeight: NewsNum == 1 ? '800' : '400' }">党建要闻</div>
					<div @click="changeNewsNum(2)" class="news_title_left_text"
						:style="{ color: NewsNum == 2 ? '#D31813' : '#999999', fontWeight: NewsNum == 2 ? '800' : '400' }">党建活动</div>
					<div @click="changeNewsNum(3)" class="news_title_left_text"
						:style="{ color: NewsNum == 3 ? '#D31813' : '#999999', fontWeight: NewsNum == 3 ? '800' : '400' }">风采展示</div>
				</div>
				<div class="right_back" @click="goHome">
					<div class="right_back_icon"><img src="../../assets/xiangning/newsCenter/back.png" alt=""></div>
					<div>返回</div>
				</div>
			</div>
			<!-- 共建共享上方标题栏 -->
			<div class="news_title" v-if="$route.query.type == 'djgj'">
				<div class="title_left">
					<img src="../../assets/xiangning/home/titile_left.png" alt="">
				</div>
				<div class="news_title_left">
					<div @click="changeDjgj(item.class_id)" v-for="item in djgjClassList" class="news_title_left_text"
						:style="{ color: NewsNum2 == item.class_id ? '#D31813' : '#999999', fontWeight: NewsNum2 == item.class_id ? '800' : '400' }">
						{{ item.title }}</div>

				</div>
				<div class="right_back" @click="goHome">
					<div class="right_back_icon"><img src="../../assets/xiangning/newsCenter/back.png" alt=""></div>
					<div>返回</div>
				</div>
			</div>
			<!-- 党务公开 -->
			<div class="news_title" v-if="$route.query.type == 'dwgk'">
				<div class="title_left">
					<img src="../../assets/xiangning/home/titile_left.png" alt="">
				</div>
				<div class="news_title_left">
					<div @click="changeNewsNum(1)" class="news_title_left_text"
						:style="{ color: NewsNum == 1 ? '#D31813' : '#999999', fontWeight: NewsNum == 1 ? '800' : '400' }">工作执行</div>
					<div @click="changeNewsNum(2)" class="news_title_left_text"
						:style="{ color: NewsNum == 2 ? '#D31813' : '#999999', fontWeight: NewsNum == 2 ? '800' : '400' }">思想建设</div>
					<div @click="changeNewsNum(3)" class="news_title_left_text"
						:style="{ color: NewsNum == 3 ? '#D31813' : '#999999', fontWeight: NewsNum == 3 ? '800' : '400' }">组织管理</div>
					<div @click="changeNewsNum(4)" class="news_title_left_text"
						:style="{ color: NewsNum == 4 ? '#D31813' : '#999999', fontWeight: NewsNum == 4 ? '800' : '400' }">班子建设</div>
					<div @click="changeNewsNum(5)" class="news_title_left_text"
						:style="{ color: NewsNum == 5 ? '#D31813' : '#999999', fontWeight: NewsNum == 5 ? '800' : '400' }">党风廉政</div>
					<div @click="changeNewsNum(6)" class="news_title_left_text"
						:style="{ color: NewsNum == 6 ? '#D31813' : '#999999', fontWeight: NewsNum == 6 ? '800' : '400' }">服务基层</div>
					<div @click="changeNewsNum(7)" class="news_title_left_text"
						:style="{ color: NewsNum == 7 ? '#D31813' : '#999999', fontWeight: NewsNum == 7 ? '800' : '400' }">其他公示</div>
				</div>
				<div class="right_back" @click="goHome">
					<div class="right_back_icon"><img src="../../assets/xiangning/dwgk/back.png" alt=""></div>
					<div>返回</div>
				</div>
			</div>
			<!-- 内容列表 -->
			<div class="news_content"  v-if="newsList.length>0">
				<!-- 新闻列表 -->
				<div class="news_content_item" @click="goNewsDetail(item)" v-for="item in newsList" :key="item.id">
					<div class="news_content_item_left_pic">
						<img v-if="class_id == 3&&$route.query.type == 'xwzx'" :src="item.img" alt="">
						<img v-else :src="item.sz_img" alt="">

					</div>
					<div class="news_content_item_right">
						<div class="news_content_item_right_toptitle">{{ item.title }}
						</div>
						<div class="news_content_item_right_center" v-html="item.content">
						</div>
						<div class="news_content_item_right_bottom">
							<span v-if="class_id == 3&&$route.query.type == 'xwzx'">{{ $changeTime(item.addtime) }}</span>
							<span v-else>{{ item.pub_time }}</span>
						</div>
					</div>
				</div>
				
			</div>
			<div v-else style="width: 100%; display: flex;justify-content: center;">
				<img style="width: 800px;margin-top: 100px; margin-bottom: 100px;" src="../../assets/xiangning/newsCenter/nodata.png" alt="">
			</div>
			<!-- 下方分页器 -->
			<div class="pagination" v-if="newsList.length>0" >
				<div class="block">
					<el-pagination @current-change="handleCurrentChange" :current-page="per_page" :page-sizes="[10]"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
import Swiper from 'swiper';
import { news } from '@/axios';
import Title from '@/components/title.vue'
export default {
	name:'news',
	data() {
		return {
			// 总数据条数
			total: 100,
			class_id: 1,
			// 当前页码
			per_page: 1,
			// 标题栏切换改变样式
			NewsNum: 1,
			NewsNum2: 1,
			index: 0,
			newsList: [],
			djgjClassList: []
		}
	},
	components: { Title },
	methods: {
		// 跳转至新闻详情
		goNewsDetail(data) {
			let that = this
			if (this.$route.query.type=='dwgk') {
				this.$router.push({
				path:'/tzgg_detail',
				query:{
					id:data.id,
					type:this.$route.query.type
				}
			   })
			}else{
				this.$router.push({
				path: '/xwxq',
				query: {
					id: data.id,
					type: that.$route.query.type,
					class_id: that.class_id,
					zy_type: data.type
				}
			})
			}
			
		},
		// 获取党务公开列表
		getDwgkList() {
			let that = this
			news.dwgkList({ page: that.per_page, class_id: that.NewsNum }).then((res) => {
				if (res.code == 200) {
					that.newsList = res.data.pagedata
					that.total = res.data.count
				}
			})
		},
		// 点击新闻中心切换标题
		changeNewsNum(val) {
			this.NewsNum = val
			this.class_id = val
			this.per_page = 1
			if (this.$route.query.type=='dwgk') {
				this.getDwgkList()
				
			}else{
				this.getNewsList()
			}
		},
		// 点击切换党建共建标题
		changeDjgj(val) {
			this.NewsNum2 = val
			this.getDjgjList()
		},
		handleCurrentChange(val) {
			this.per_page = val
			if (this.$route.query.type=='dwgk') {
				this.getDwgkList()
				
			}else if (this.$route.query.type=='djgj') {
				this.getDjgjList()
			}
			else{
				this.getNewsList()
			}
		},

		goHome() {
			this.$router.push({
				path: '/home'
			})
		},
		getNewsList() {
			let that = this
			news.newshList({ class_id: that.class_id, page: that.per_page }).then((res) => {
				if (res.code == 200) {
					that.total = res.data.count
					that.newsList = res.data.pagedata
				}
			})
		},

		// 获取党建共建分类
		getDjgjClass() {
			let that = this
			news.djgjClassList().then((res) => {
				if (res.code == 200) {
					that.djgjClassList = res.data

					if (that.$route.query.class_id) {
						that.NewsNum2 = that.$route.query.class_id
					} else { that.NewsNum2 = res.data[0].class_id }
					that.getDjgjList()
				}
			})
		},
		// 获取党建共建列表
		getDjgjList() {
			let that = this
			news.djgjList({ class_id: that.NewsNum2, page: that.per_page }).then((res) => {
				if (res.code == 200) {
					
					that.total = res.data.count
					that.newsList = res.data.pagedata

				}
			})
		},

	},
	mounted() {
		let that = this


		// 如果是党建共建
		if (this.$route.query.type == 'djgj') {

			// 获取党建共建标题分类
			that.getDjgjClass()



		} else if (this.$route.query.type == 'xwzx') {
			//  向服务器发起请求获取新闻列表
			this.getNewsList()
		}else if(this.$route.query.type=='dwgk'){
              this.getDwgkList()
		   }
		// 
	},
	created() {
		// this.$emit("highLight",1,"","","");
	}
}
</script>

<style lang="scss">
@import '@/common/index.scss';

.index {
	width: 100%;

	.newsCenterBanenr {
		position: relative;
		width: 100%;

		img {
			width: 100%;
			height: auto;
		}

	}

	div {
		box-sizing: border-box;
	}

	.Interpretation_content {
		width: 100%;
		margin-top: 20px;

		.shizheng_right_item {
			position: relative;
			height: 67px;
			width: 100%;
			border-bottom: 1px solid #ECEEF4;
			display: flex;
			justify-content: space-between;
			overflow: hidden;

			.shizheng_right_item_left {
				height: 100%;
				width: 44px;
				padding: 10px 0;
				margin-right: 10px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.year {
					font-family: PingFangSC-Regular;
					font-size: 18px;
					font-weight: normal;
					text-align: center;
					letter-spacing: 0px;
					color: #333333;
				}

				.mouth {
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					text-align: center;
					letter-spacing: 0px;
					color: #999999;
				}
			}

			.shizheng_right_item_right {
				height: 100%;
				width: 793px;
				padding: 10px 0 10px 20px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.title_top {
					width: 710px;
					font-family: PingFangSC-Regular;
					font-size: 14px;
					font-weight: normal;
					letter-spacing: 0px;
					color: #000000;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}

				.title_top:hover {
					color: #EE632B;
					font-weight: 800;
				}

				.content_bottom {
					width: 98%;
					font-family: MicrosoftYaHei;
					font-size: 12px;
					font-weight: normal;
					letter-spacing: 0px;
					color: #999999;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}

			.shizheng_right_item_center {
				position: absolute;
				width: 2px;
				height: 20px;
				opacity: 1;
				background: #EE632B;
				top: 20px;
				left: 54px;
			}

		}
	}

	.home_wrap {
		width: $indexWidth;
		margin: auto;
		min-width: 1200px;

		/* 标题部分样式 */
		.news_title {

			height: 32px;
			width: 100%;
			margin: 20px 0;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding-left: 32px;
			background: #FFF6F1;
			box-sizing: border-box;
			position: relative;

			.title_left {
				position: absolute;
				top: -5px;
				left: 0;
				height: 42px;
				width: 42px;

				img {
					width: 100%;
					height: 100%;
				}
			}
		}

		.news_title_left {
			height: 22px;
			display: flex;
			justify-content: space-between;

		}

		.news_title_left_text {
			height: 22px;
			// width: 80px;
			padding: 0 20px;
			font-family: PingFangSC-Regular;
			font-size: 16px;
			font-weight: normal;
			letter-spacing: 0.1em;
			color: #999999;
		}

		.right_back {
			display: flex;
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			letter-spacing: 0em;
			color: #666666;
			margin-right: 10px;
		}

		.right_back:hover {
			font-weight: 800;
			color: #EE632B;
		}

		.right_back_icon {
			height: 10px;
			width: 12px;
			margin-right: 5px;
		}

		.right_back_icon img {
			height: 100%;
			width: 100%;
		}

		/* 内容部分样式 */
		.news_content {
			// height: 754px;
			width: 100%;
			overflow: hidden;
			/* background-color: pink; */
		}

		.news_content_item {
			height: 188px;
			width: 100%;
			/* background-color: skyblue; */
			border-bottom: 1px solid #ECEEF4;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.news_content_item_left_pic {
			height: 168px;
			width: 270px;
		}

		.news_content_item_left_pic img {
			width: 100%;
			height: 100%;
		}

		.news_content_item_right {
			height: 134px;
			width: 900px;
			/* background-color: pink; */
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}

		.news_content_item_right_toptitle {
			height: 20px;
			width: 80%;
			font-family: PingFangSC-Medium;
			font-size: 14px;
			font-weight: 800;
			letter-spacing: 0px;

			color: #000000;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.news_content_item_right_toptitle:hover {
			color: #EE632B;
		}

		.news_content_item_right_center {
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			line-height: 20px;
			text-align: justify;
			/* 浏览器可能不支持 */
			letter-spacing: 0px;
			color: #666666;
			width: 100%;
			max-height: 82px;
			overflow: hidden;
			text-overflow: ellipsis;
			/* 将对象作为弹性伸缩盒子模型显示 */
			display: -webkit-box;
			/* 限制在一个块元素显示的文本的行数 */
			/* -webkit-line-clamp 其实是一个不规范属性，使用了WebKit的CSS扩展属性，该方法适用于WebKit浏览器及移动端；*/
			-webkit-line-clamp: 4;
			/* 设置或检索伸缩盒对象的子元素的排列方式 */
			-webkit-box-orient: vertical;

		}

		.news_content_item_right_bottom {
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			line-height: 20px;
			text-align: justify;
			/* 浏览器可能不支持 */
			letter-spacing: 0px;
			color: #666666;
			display: flex;
			justify-content: right;
		}

		/* .分页器 */

		.pagination {
			height: 48px;
			width: 648px;
			margin: 0 auto;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #EE632B;
			margin-bottom: 30px;
		}


		.el-pagination .el-pager li:hover {
			color: #EE632B;
		}

		.el-pagination .el-pager li:not(.disabled):hover {
			color: #EE632B;
		}

		.el-pagination .el-pager li:not(.disabled).active {

			color: #EE632B;
		}

		.el-pagination .btn-prev:hover {

			color: #EE632B;
		}

		.el-pagination .btn-next:hover {
			color: #EE632B;
		}

		li.el-select-dropdown__item.selected {
			color: #EE632B !important;
		}

		.el-input__inner:hover {
			border-color: #EE632B !important;
		}

		.el-input__inner:focus {
			border-color: #EE632B !important;
		}

	}
}</style>
